import * as request from '@/utils/request'

const BASE_URL = '/paas/new_tax_invoice_upgrade'

export default {
  // 待开票账单汇总列表
  getNewTaxInvoiceBillRecords(params) {
    return request.get(`${BASE_URL}/bill_records`, params)
  },

  // 待开票多条记录列表
  getNewTaxInvoicePendingRecords(params) {
    return request.get(`${BASE_URL}/pending_records`, params)
  },

  // 申请开票弹窗初始化
  getNewTaxInvoiceApplyInit(params) {
    return request.get(`${BASE_URL}/apply_init`, params)
  },

  // 获取开票类目
  getNewTaxInvoiceContent(id, params) {
    return request.get(`${BASE_URL}/content/${id}`, params)
  },

  // 批量申请开票/合并开票
  batchApplyNewTaxInvoice(data) {
    return request.post(`${BASE_URL}/batch_apply`, data)
  },

  // 已开票金额列表
  getNewTaxInvoiceOpenedRecords(params) {
    return request.get(`${BASE_URL}/opened_records`, params)
  },

  // 获取开票详情
  getNewTaxInvoiceDetail(id, params) {
    return request.get(`${BASE_URL}/detail/${id}`, params)
  },

  // 勾选已开票记录批量获取下载地址
  downloadNewTaxInvoiceOpenedRecords(data) {
    return request.post(`${BASE_URL}/opened_records/download`, data)
  },

  // 按公司税源地打包下载全部发票
  downloadAllNewTaxInvoiceOpenedRecords(data) {
    return request.post(`${BASE_URL}/opened_records/download_all`, data)
  },

  // 兼容旧页面方法名，统一指向升级版接口
  getNewTaxInvoiceBills(params) {
    return request.get(`${BASE_URL}/bill_records`, params)
  },

  getNewTaxInvoiceRecords(params) {
    return request.get(`${BASE_URL}/bill_records`, params)
  },

  applyNewTaxInvoice(data) {
    return request.post(`${BASE_URL}/batch_apply`, data)
  },
}
